import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlMcFieldsFragment = { id: string, meetingId: string, shareIssueId?: string | null, warrantProgramId?: string | null, articlesOfAssocId?: string | null, authorizationGroupId?: string | null, approved?: boolean | null, appendixNumber: number, createdAt: string, updatedAt: string };

export const McFieldsFragmentDoc = gql`
    fragment McFields on MeetingConcern {
  id
  meetingId
  shareIssueId
  warrantProgramId
  articlesOfAssocId
  authorizationGroupId
  approved
  appendixNumber
  createdAt
  updatedAt
}
    `;